import React, { useState } from "react";
import { BsBriefcaseFill } from "react-icons/bs";
import PageHeaderContent from "../../components/pageHeaderContent";

import vid1 from "../../images/Portfolio Images/vid1.mp4";
import vid2 from "../../images/Portfolio Images/vid2.mp4";
import vid3 from "../../images/Portfolio Images/vid3.mp4";
import vid4 from "../../images/Portfolio Images/vid4.mp4";
import vid5 from "../../images/Portfolio Images/vid5.mp4";
import vid6 from "../../images/Portfolio Images/vid6.mp4";
import vid7 from "../../images/Portfolio Images/vid7.mp4";
import vid8 from "../../images/Portfolio Images/vid8.mp4";
import vid9 from "../../images/Portfolio Images/vid9.mp4";
import vid10 from "../../images/Portfolio Images/vid10.mp4";
import vid11 from "../../images/Portfolio Images/vid11.mp4";
import vid12 from "../../images/Portfolio Images/vid12.mp4";
import vid13 from "../../images/Portfolio Images/vid13.mp4";

import "./style.scss";

const portfolioData = [
  {
    id: 2,
    name: "LC Loan Data Analysis",
    media: vid6,
    link: "https://github.com/TechPodx/data-science-and-machine-learning-projects/tree/main/Project%20No%202%20-%20Lending%20Club",
  },
  {
    id: 2,
    name: "Birds vs Drones Detection",
    media: vid7,
    link: "https://github.com/TechPodx/data-science-and-machine-learning-projects/tree/main/Project%20No%203%20-%20Birds%20vs%20Drones%20Detection",
  },
  {
    id: 3,
    name: "Protfolio Web",
    media: vid8,
    link: "https://github.com/TechPodx/app-dev-projects/tree/main/Project%20No%206%20-%20Portfolio%20Website/my-portfolio-website",
  },
  {
    id: 3,
    name: "Cine Explore",
    media: vid1,
    link: "https://github.com/TechPodx/app-dev-projects/tree/main/Project%20No%205%20-%20React%20-%20Movie%20Browing%20Web%20App/cine-explore",
  },
  {
    id: 3,
    name: "SoundCore",
    media: vid2,
    link: "https://github.com/TechPodx/app-dev-projects/tree/main/Project%20No%204%20-%20Spotify%20Clone/spotify-clone",
  },
  {
    id: 3,
    name: "Keyboard",
    media: vid3,
    link: "https://github.com/TechPodx/app-dev-projects/tree/main/Project%20No%203%20-%20Realistic%20Music%20Keyboard",
  },
  {
    id: 3,
    name: "Payroll System",
    media: vid4,
    link: "https://github.com/TechPodx/app-dev-projects/tree/main/Project%20No%202%20-%20PayRoll%20Management%20System%20Using%20C%23.Net",
  },
  {
    id: 3,
    name: "Message Generator",
    media: vid5,
    link: "https://github.com/TechPodx/app-dev-projects/tree/main/Project%20No%201%20-%20Message%20Generator",
  },
  {
    id: 4,
    name: "RPA: Employee & Mail ID",
    media: "",
    link: "",
  },
  {
    id: 4,
    name: "RPA: Sales Report",
    media: "",
    link: "",
  },
  {
    id: 4,
    name: "RPA: HR Admission Process",
    media: "",
    link: "",
  },
  {
    id: 5,
    name: "Pharma Data Analysis",
    media: vid12,
    link: "https://github.com/TechPodx/data-analytics-projects/tree/main/Project%2003%20-%20Pharmaceutical%20Sales%20Data%20Analysis%20-%20Excel%20and%20Power%20BI",
  },
  {
    id: 5,
    name: "Port Activity BI",
    media: vid11,
    link: "https://github.com/TechPodx/data-analytics-projects/tree/main/Project%2002%20-%20Global%20Daily%20Port%20Activity%20and%20Trade%20Estimates",
  },
  {
    id: 5,
    name: "Energy BI",
    media: vid10,
    link: "https://github.com/TechPodx/data-analytics-projects/tree/main/Project%2001%20-%20Renewable%20Traceability%20%26%20Carbon%20Performance%20Dashboard",
  },
  {
    id: 5,
    name: "Pizza Sales BI",
    media: vid9,
    link: "https://github.com/TechPodx/data-analytics-projects/tree/main/Project%2000%20-%20Pizza%20Sales%20Data%20Analysis",
  },
  {
    id: 5,
    name: "Water Utility BI",
    media: vid13,
    link: "https://github.com/TechPodx/data-analytics-projects/tree/main/Project%2004%20-%20B2B%20Water%20Efficiency%20%26%20Leak%20Detection%20Hub",
  }
];

const filterData = [
  {
    filterId: 1,
    label: "All",
  },
  {
    filterId: 2,
    label: "Data Science & ML",
  },
  {
    filterId: 3,
    label: "App Dev",
  },
  {
    filterId: 4,
    label: "RPA",
  },
  {
    filterId: 5,
    label: "Analytics",
  },
];

const Portfolio = () => {
  const [filteredValue, setFilteredValue] = useState(1);
  const [hoveredValue, setHoveredValue] = useState(null);

  function handleFilter(currentId) {
    setFilteredValue(currentId);
  }

  function handleHover(index) {
    setHoveredValue(index);
  }

  const filteredItems =
    filteredValue === 1
      ? portfolioData
      : portfolioData.filter((item) => item.id === filteredValue);

  return (
    <section id="portfolio" className="portfolio">
      <PageHeaderContent
        headerText="My Portfolio"
        icon={<BsBriefcaseFill size={40} />}
      />
      <div className="portfolio_content">
        <ul className="portfolio_content_filter">
          {filterData.map((item) => (
            <li
              className={item.filterId === filteredValue ? "active" : ""}
              onClick={() => handleFilter(item.filterId)}
              key={item.filterId}
            >
              {item.label}
            </li>
          ))}
        </ul>
        <div className="portfolio_content_cards">
          {filteredItems.map((item, index) => (
            <div
              className="portfolio_content_cards_item"
              key={`cardItem${item.name.trim()}`}
              onMouseEnter={() => handleHover(index)}
              onMouseLeave={() => handleHover(null)}
            >
              <div className="portfolio_content_cards_item_img_wrapper">
                <div>
                  <video
                    autoPlay
                    loop
                    muted
                    src={item.media}
                    type="video/mp4"
                  ></video>
                </div>
              </div>
              <div className="overlay">
                {index === hoveredValue && (
                  <div>
                    <p>{item.name}</p>
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button>Visit</button>
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
